import { Td,Tr , IconButton, HStack, Badge} from "@chakra-ui/react";
import { IoTrashOutline } from "react-icons/io5";
import { CiEdit, CiPause1, CiPlay1 } from "react-icons/ci";
import type { CompanyTableItemProps } from "./types";

const CompanyTableItem = ({ item, onPressEdit, onPressDelete, onPressPlayStop }:CompanyTableItemProps) => {
    return(
        <Tr>
            <Td>{item.nombre}</Td>
            <Td>{item.fechaCreacion ?? 'Sin fecha'}</Td>
            <Td>{item.fechaActualizacion ?? 'Sin fecha'}</Td>
            <Td>
            <Badge 
                    borderRadius={300} 
                    px={2} 
                    py={1}
                    w={90}
                    fontSize="xs"
                    fontWeight={700}
                    textAlign="center" 
                    bg={Number(item.estatus) === 1 ? "green.200" : 'red.200'}
                >
                    {Number(item.estatus) === 1 ? 'activo' : 'inactivo'}
                </Badge>
            </Td>
            <Td isNumeric>
                <HStack justifyContent="end">
                    {
                        Number(item.estatus) === 1 
                        ? (
                            <IconButton 
                                aria-label="Stop"
                                variant='ghost'
                                colorScheme="teal"
                                icon={<CiPause1 size={20}/> }
                                onClick={() => onPressPlayStop({ id: item.id, action: 'inactive' })}
                            />
                        ) : (
                            <IconButton
                                aria-label="Play"
                                variant='ghost'
                                colorScheme="teal"
                                icon={<CiPlay1 size={20} />}
                                onClick={() => onPressPlayStop({ id: item.id, action: 'active' })} 
                            />
                        )
                    }
                    
                    <IconButton 
                        aria-label="Delete" 
                        variant='ghost' 
                        colorScheme="red" 
                        icon={<IoTrashOutline size={18}/>}
                        onClick={() => onPressDelete(item)}
                    />
                    <IconButton 
                        aria-label="Edit" 
                        variant='ghost' 
                        colorScheme="teal" 
                        icon={<CiEdit size={20}/>}
                        onClick={() => onPressEdit(item)} 
                    />
                </HStack>
            </Td>
        </Tr>
    )
}

export default CompanyTableItem